import React from "react";
import PropTypes from "prop-types";
//Material imports
import Grid from "@mui/material/Grid";
import LandingTooltip from "../landing-tooltip/LandingTooltip";
import RadioGroup from "@mui/material/RadioGroup";
// Limitless imports
import Typography from "@limitless/modern/data-display/typography/Typography";
import RadioButton from "@limitless/modern/inputs/radio-button/RadioButton";
const RadioSelection = ({
  content,
  onValueChange,
  values
}) => {
  const {
    stateCaptureKey,
    options,
    header,
    tooltip,
    verticalRadioUi = false
  } = content;
  const {
    value = ""
  } = values ? values[stateCaptureKey] : {};
  return /*#__PURE__*/React.createElement(Grid, {
    container: true
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    alignItems: "center",
    wrap: "nowrap",
    mt: 2
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body2"
  }, header), tooltip && /*#__PURE__*/React.createElement(LandingTooltip, {
    tooltip: tooltip
  })), /*#__PURE__*/React.createElement(RadioGroup, {
    row: !verticalRadioUi,
    onChange: (e, value) => onValueChange && onValueChange(stateCaptureKey, e.target.value),
    value: value
  }, options === null || options === void 0 ? void 0 : options.map((item, index) => {
    return item.label !== "" && item.value !== "" && /*#__PURE__*/React.createElement(RadioButton, {
      label: item.label,
      value: item.value,
      key: index,
      componentsProps: {
        typography: {
          variant: "body2",
          color: theme => theme.palette.info.contrastText,
          paddingLeft: 1,
          paddingRight: 2
        }
      },
      sx: {
        margin: "2px 8px 0px 2px"
      }
    });
  })));
};
export default RadioSelection;
RadioSelection.propTypes = {
  content: PropTypes.object.isRequired,
  onValueChange: PropTypes.func,
  values: PropTypes.object
};